import Base from './base'

export default class TwoFactorApi extends Base {
  setup() {
    return this.apiClient.post('auth/2fa/setup')
  }

  enable(data: { secret: string; verificationCode: string; backupCodes: string[] }) {
    return this.apiClient.post('auth/2fa/enable', data)
  }

  verify(data: { tempUserId: string; code: string; isBackupCode?: boolean }) {
    return this.apiClient.post('auth/2fa/verify', data)
  }

  disable(data: { password: string }) {
    return this.apiClient.post('auth/2fa/disable', data)
  }
}
